import { AxiosError } from 'axios'
import { toastStore } from 'shared/ui'
import { SurveysApi } from 'entities/Surveys'
import type { IResponseFilterSegment } from 'entities/Segment'

const getErrorMessage = (e: unknown): string | null => {
  if (e instanceof AxiosError) {
    return e.errors.getError('message') || null
  }
  return null
}

export class SurveySendModalStore {
  enrollContacts = ({
    surveyId,
    contactIds,
    applyFilters,
  }: {
    surveyId: number
    contactIds: number[]
    applyFilters: boolean
  }) =>
    SurveysApi.enrolmentSurvey({
      id: surveyId,
      data: {
        contact_ids: contactIds,
        apply_filters: applyFilters,
      },
    }).then(
      () => {
        toastStore.add({
          type: 'success',
          title: applyFilters
            ? `Contact${contactIds.length > 1 ? 's' : ''} will be engaged if ${
                contactIds.length > 1 ? 'they match' : 'it matches'
              } enrollment criteria`
            : `Contact${contactIds.length > 1 ? 's' : ''} will be engaged in the survey`,
        })
        return true
      },
      (e: unknown) => {
        toastStore.add({
          type: 'error',
          title:
            getErrorMessage(e) || `Unable to engage contact${contactIds.length > 1 ? 's' : ''}`,
        })
        return false
      }
    )

  enrollContactsByFilters = ({
    surveyId,
    applyFilters,
    filtersList,
    search,
    bulkAll,
  }: {
    surveyId: number
    applyFilters: boolean
    filtersList?: IResponseFilterSegment[]
    search?: string
    bulkAll?: boolean
  }) =>
    SurveysApi.enrolmentSurvey({
      id: surveyId,
      data: {
        apply_filters: applyFilters,
        contact_filters: filtersList,
        search,
        apply_to_all: bulkAll,
      },
    }).then(
      () => {
        toastStore.add({
          type: 'success',
          title: applyFilters
            ? 'Contacts will be engaged if they match enrollment criteria'
            : 'Contacts will be engaged in the survey',
        })
        return true
      },
      (e: unknown) => {
        toastStore.add({
          type: 'error',
          title: getErrorMessage(e) || 'Unable to engage contacts',
        })
        return false
      }
    )
}
